export default function Benefits() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-5xl mx-auto px-8">
        <div className="mb-16">
          <div className="rounded-3xl overflow-hidden shadow-xl">
            <img
              src="https://public.readdy.ai/ai/img_res/047377c5a6a40e259ffaff93ca2f8b7a.jpg"
              alt="複合機を使用するオフィス"
              className="w-full h-96 object-cover object-top"
            />
          </div>
        </div>

        <div className="text-center mb-12">
          <p className="text-4xl leading-relaxed text-gray-900">
            <span className="font-light italic text-gray-400">本体費用0円</span>
            <span className="font-bold">で始められる、</span><br />
            <span className="font-bold">充実の</span>
            <span className="font-light italic text-gray-400">メンテナンス込み</span>
            <span className="font-bold">プラン。</span><br />
            <span className="font-light italic text-gray-400">複数機種</span>
            <span className="font-bold">をいつでもご利用いただけます。</span>
          </p>
        </div>
      </div>
    </section>
  );
}
